"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _material = require("@mui/material");

var _Tab = require("../Tab");

var _muiSelectors = require("../../utilities/mui-selectors");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["tabs"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledMuiTabs = (0, _material.styled)(_material.Tabs)(function (_ref) {
  var _ref2;

  var theme = _ref.theme;
  return _ref2 = {}, (0, _defineProperty2.default)(_ref2, "&.".concat(_muiSelectors.classes.components.MuiTabs.root), {
    minHeight: theme.spacing(7)
  }), (0, _defineProperty2.default)(_ref2, "& .".concat(_muiSelectors.classes.components.MuiTabs.flexContainer), {
    margin: "1px 2px"
  }), (0, _defineProperty2.default)(_ref2, "& .".concat(_muiSelectors.classes.components.MuiTabs.indicator), {
    backgroundColor: theme.palette.primary.main,
    bottom: theme.spacing(1),
    height: 2
  }), _ref2;
});

var Tabs = function Tabs(_ref3) {
  var tabs = _ref3.tabs,
      props = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledMuiTabs, _objectSpread(_objectSpread({}, props), {}, {
    children: tabs.map(function (tab) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tab.Tab, _objectSpread({}, tab), tab.value);
    })
  }));
};

var _default = Tabs;
exports.default = _default;